import { ensureLocalStorageSafely } from './utils/ensureLocalStorageSafely';

ensureLocalStorageSafely();
import('./bootstrap');
